import type { AppState } from "./app-source.js";
import { type Guidance, undefendedAttacks } from "./guidance.js";
import { type AppNode, appAction, text } from "./view-nodes.js";

export function advisorToggle(state: AppState): AppNode {
  return {
    kind: "toggle-input",
    id: "enable-advisor",
    label: "Enable advisor",
    value: state.advisorEnabled ?? false,
    intent: (enabled) => ({ kind: "set-advisor", enabled }),
  };
}

export function attackWarnings(state: AppState): AppNode[] {
  if (!state.observation || state.replayActive) return [];
  return undefendedAttacks(state.observation).map((warning) => ({
    kind: "section" as const,
    id: warning.id,
    style: { className: "kf-attack-warning" },
    children: [
      {
        kind: "notification",
        id: `${warning.id}-announcement`,
        tone: "danger",
        text: `Under attack: ${state.observation?.seats.find((seat) => seat.id === warning.borderId)?.name} border has no defenders.`,
      },
      navigate(warning),
    ],
  }));
}

export function guidanceView(state: AppState): AppNode[] {
  if (state.replayActive) return [];
  const tip = state.advice;
  if (!tip) return [];
  return [
    {
      kind: "section",
      id: "practice-advisor",
      variant: "card",
      style: { className: "kf-advisor" },
      children: [
        { kind: "notification", id: `advisor-${tip.id}`, text: `Advisor · ${tip.message}` },
        navigate({ ...tip, message: `Show me → ${tip.tab}` }),
        appAction("dismiss-advice", "Got it — dismiss this suggestion", {
          kind: "dismiss-advice",
          id: tip.id,
        }),
        text(
          "advisor-note",
          "Suggestions, not orders. Resolved issues disappear; dismissed suggestions stay quiet until the condition clears.",
        ),
      ],
    },
  ];
}

function navigate(tip: Guidance): AppNode {
  return appAction(`open-${tip.id}`, tip.message, { kind: "open-guidance", guidance: tip });
}
